export default __webpack_public_path__ + "static/media/pict_logo.b966b663.png";